import React from 'react'
import PropTypes from 'prop-types'

export const Indicator = props => {
  let visible = props.display ? 'visible' : 'hidden'
  let indicatorStyle = {
    color: '#ff5c35',
    fontSize: '2em',
    verticalAlign: 'baseline',
    position: 'relative',
    top: props.top ? props.top : '0.1em',
    fontFamily: 'var(--font-ui)',
    visibility: visible,
  }

  return (
    <React.Fragment>
      <span style={indicatorStyle}>* </span>
    </React.Fragment>
  )
}

Indicator.propTypes = {
  display: PropTypes.bool,
}
